export default __webpack_public_path__ + "static/110-min-min-e979e72ea3400b19eb6cc6c936ce0168.jpg";